<template>
  <v-container fluid>
    <v-layout column>
      <v-card>
        <v-card-title>Command</v-card-title>
        <v-card-text>
          <v-textarea clearable label="Command" v-model="command"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="execute">Run</v-btn>
          <v-btn @click="exportCsv">Export</v-btn>
        </v-card-actions>
      </v-card>
      <v-card>
        <v-card-title>Result</v-card-title>
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="result"
            :rows-per-page-items="[10]"
            class="elevation-0"
          >
            <template slot="items" slot-scope="props">
              <td :key="i" v-for="(v,i) in props.item">{{props.item[i]}}</td>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      command: null,
      headers: [],
      result: []
    };
  },
  methods: {
    execute() {
      this.$http.post("/maintain", { sql: this.command }).then(res => {
        this.headers = res.data.cols.map(c => ({
          text: c,
          value: c
        }));
        this.result = res.data.data;
      });
    },
    exportCsv() {
      let headers = this.headers.map(h => h.text);
      this.$exportTable(this.result, headers, headers, "maintain", true);
    }
  }
};
</script>
